import { BaseContainerModel } from "../../../../base-container.model";
import { contact_merger_record_RowClass } from "./contact_merger_record.model";

export class ContactMergerSearchContainerModel extends BaseContainerModel {
    contact_merger_record: contact_merger_record_RowClass;
}